import { API_ROOT } from '../../config/config'
import { doGet, doPost, doPut, doDeleteData, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:9005/api'
//const API_ROOT2 = 'http://localhost/api'

export const getAssessmentConfigPage = () => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/page`
  return doGet(url)
}

export const copyAssessmentConfig = (id, request = {}) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/${id}/copy`
  return doPost(url, request)
}

export const deleteAssessmentConfig = (id, request = {}) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/${id}/delete`
  return doDeleteData(url, request)
}

export const getAssessmentConfigType = (type = 0) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/type/${type}`
  return doGet(url)
}

export const getAssessmentConfigForm = (id) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/form?id=${id}`
  return doGet(url)
}

export const saveAssessmentConfigType = (request) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/type`
  return doPut(url, request)
}

export const saveAssessmentConfigForm = (request) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/form-question`
  return doPut(url, request)
}

export const saveAssessmentConfigFormHeader = (request) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/form-header`
  return doPut(url, request)
}

export const GetAssessmentMAndEPage = (pageNum, pageSize) => {
  const url = `${API_ROOT}/progress/assessment/m-e/page?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doGet(url)
}

export const GetAssessmentMAndESearch = (request) => {
  const url = `${API_ROOT}/progress/assessment/m-e/page/search`
  return doPost(url, request)
}

export const GetAssessmentMAndEForm = (projectCode, id, assessmentId) => {
  const url = `${API_ROOT}/progress/assessment/m-e/form/${projectCode}?id=${
    id || ''
  }&assessmentId=${assessmentId || ''}`
  return doGet(url)
}

export const SaveAssessmentMAndEForm = (request, projectCode) => {
  const url = `${API_ROOT}/progress/assessment/m-e/form/${projectCode}`
  return doPost(url, request)
}

export const SendAssessmentMAndEForm = (request) => {
  const url = `${API_ROOT}/progress/assessment/m-e/form/send`
  return doPut(url, request)
}

export const GetAssessmentMAndESelfPage = (pageNum, pageSize) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/page?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doGet(url)
}

export const GetAssessmentMAndESelfSearch = (request) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/page/search`
  return doPost(url, request)
}

export const GetAssessmentMAndESelfSummaryPage = (pageNum, pageSize) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/summary/page?pageNum=${
    pageNum || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const GetAssessmentMAndESelfSummarySearch = (request) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/summary/page/search`
  return doPost(url, request)
}

export const SendAssessmentMAndESelfNoti = (request) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/noti/${request.projectCode}`
  return doPut(url, request)
}

export const GetAssessmentMAndESelfForm = (projectCode, id, assessmentId) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/form/${projectCode}?id=${
    id || ''
  }&assessmentId=${assessmentId || ''}`
  return doGet(url)
}

export const SaveAssessmentMAndESelfForm = (request, projectCode) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/form/${projectCode}`
  return doPost(url, request)
}

export const GetAssessmentMAndESelfForm2 = (projectCode, email) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/form2/${projectCode}?email=${email || ''}`
  return doGet(url)
}

export const SaveAssessmentMAndESelfForm2 = (request, projectCode) => {
  const url = `${API_ROOT}/progress/assessment/m-e/self/form2/${projectCode}`
  return doPost(url, request)
}

export const GetAssessmentPrePostTestForm = (questionType, assessmentId, id) => {
  const url = `${API_ROOT}/progress/assessment/pre-post/form?questionType=${
    questionType || 0
  }&assessmentId=${assessmentId || ''}&id=${id || ''}`
  return doGet(url)
}

export const SaveAssessmentPrePostTestForm = (request) => {
  const url = `${API_ROOT}/progress/assessment/pre-post/form`
  return doPost(url, request)
}

export const GetAssessmentMAndEManageCBTeam = (projectCode, id) => {
  const url = `${API_ROOT}/progress/assessment/m-e/manage-cb-team/${projectCode}?id=${id || ''}`
  return doGet(url)
}

export const SaveAssessmentMAndEManageCBTeam = (request) => {
  const url = `${API_ROOT}/progress/assessment/m-e/manage-cb-team/save`
  return doPut(url, request)
}

export const DeleteAssessmentMAndEManageCBTeam = (projectCode, id) => {
  const url = `${API_ROOT}/progress/assessment/m-e/manage-cb-team/${projectCode}/${id}/delete`
  return doDeleteData(url)
}

export const deleteAssessmentConfigFormByQuestionId = (id) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/form-question/${id}`
  return doDeleteData(url)
}

export const deleteAssessmentConfigFormByCategoryId = (categoryId) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/form/${categoryId}`
  return doDeleteData(url)
}

export const updateAssessmentConfigCategoryForm = (request) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/form/category-update`
  return doPut(url, request)
}

export const getAssessmentForm = (
  id,
  projectCode,
  projectVersionId,
  period,
  categoryType,
  progressId,
  assessmentFor
) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/form?id=${id || ''}&projectCode=${
    projectCode || ''
  }&projectVersionId=${projectVersionId || ''}&period=${period || ''}&categoryType=${
    categoryType || ''
  }&progressId=${progressId || ''}&assessmentFor=${assessmentFor || ''}`
  return doGet(url)
}

export const saveAssessmentForm = (request) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/form/save`
  return doPut(url, request)
}

// รายงาน
export const getAssessmentReportPage = (type, pageNum, pageSize) => {
  const url = `${API_ROOT}/progress/assessment/report/${type}?pageNum=${pageNum || 0}&pageSize=${
    pageSize || 0
  }`
  return doGet(url)
}

export const searchAssessmentReport = (request, type) => {
  const url = `${API_ROOT}/progress/assessment/report/${type}`
  return doPost(url, request)
}

export const exportAssessmentReport = (request, type) => {
  const url = `${API_ROOT}/progress/assessment/report/export/${type}`
  return doPostDownload(url, request)
}

// ผอ.สรุปแบบประเมินปิด
export const getAssessmentClosureApprove = (projectCode, projectVersionId) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/closure/approve?projectCode=${
    projectCode || ''
  }&projectVersionId=${projectVersionId || ''}`
  return doGet(url)
}

// ตั้งค่า master คำถามแบบประเมินปิด
export const getAssessmentConfigMasterClosureQuestion = () => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/master-closure-question`
  return doGet(url)
}

export const saveAssessmentConfigMasterClosureQuestion = (request) => {
  const url = `${API_ROOT}/progress/project/evaluation/assessment/config/master-closure-question`
  return doPut(url, request)
}

export const getMasterSetting = () => {
  const url = `${API_ROOT}/progress/assessment/master/setting`
  return doGet(url)
}

export const saveMasterUnitType = (request) => {
  const url = `${API_ROOT}/progress/assessment/master/unit-type`
  return doPost(url, request)
}

export const delMasterUnitType = (id) => {
  const url = `${API_ROOT}/progress/assessment/master/unit-type/${id}`
  return doDeleteData(url)
}

// นำเข้าข้อมูล Node
export const getImportNodePage = (pageNumber, pageSize) => {
  const url = `${API_ROOT}/progress/assessment/import/node-data/page?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const processImportNode = (request) => {
  const url = `${API_ROOT}/progress/assessment/import/node-data/process`
  return doPost(url, request)
}
